import { Box, Spinner, Td } from "@chakra-ui/react";
import { isNumber } from "lodash";
import { ReceivedBseBidDto, WinningProductGroupBidsDto } from "../../../../../autogen/bff-api";
import { Product, ProductGroup } from "../../../../../common/types";
import { useNegotiation } from "../NegotiationContext";
import { useIsAwardedProduct } from "./useIsAwardedProduct";
import { useIsBestProductPrice } from "./useIsBestProductPrice";
import { useProductBid } from "./useProductBid";
import { useRemoveProductBid } from "./useRemoveProductBid";
import { useSelectProductBid } from "./useSelectProductBid";
import { useTotalProductPrice } from "./useTotalProductPrice";

export const SelectPriceCell = ({
  bid,
  bids,
  product,
  group,
  selectedBids,
}: {
  bid: ReceivedBseBidDto;
  bids: ReceivedBseBidDto[];
  product: Product;
  group: ProductGroup;
  selectedBids: WinningProductGroupBidsDto[];
}) => {
  const { currentRound } = useNegotiation();
  const productBid = useProductBid({ productId: product.id, groupId: group.id, bid });
  const isBestProductPrice = useIsBestProductPrice({ bidId: bid.id, productId: product.id, group, bids });
  const isAwardedProduct = useIsAwardedProduct({ group, productId: product.id, bidId: bid.id, bids, selectedBids });
  const totalProductPrice = useTotalProductPrice({ productId: product.id, group, bid });
  const { selectProductBid, isLoading: isSelecting } = useSelectProductBid({
    bid,
    productId: product.id,
    group,
    eventId: bid.forSourcingEventId,
    negotiationRoundId: currentRound?.id,
  });
  const { removeProductBid, isLoading: isRemoving } = useRemoveProductBid({
    bid,
    productId: product.id,
    group,
    eventId: bid.forSourcingEventId,
    negotiationRoundId: currentRound?.id,
  });

  return (
    <Td
      key={bid.id}
      position="relative"
      textAlign="right"
      verticalAlign="top"
      cursor={productBid && isNumber(totalProductPrice) ? "pointer" : "default"}
      color={isBestProductPrice ? "green.500" : "yellow.500"}
      fontWeight={isAwardedProduct ? "bold" : "normal"}
      pt="3"
      onClick={() => {
        if (!isNumber(totalProductPrice)) return;
        else if (isAwardedProduct) removeProductBid();
        else selectProductBid();
      }}
    >
      {(isSelecting || isRemoving) && (
        <Box position="absolute" left="1" px="4" py="1">
          <Spinner color="smPrimarySoft" size="sm" />
        </Box>
      )}
      <Box
        width="40"
        height="full"
        rounded="md"
        px="4"
        py="1"
        border={isAwardedProduct ? "1px" : "none"}
        borderColor="gray.300"
        float="right"
      >
        {totalProductPrice?.toLocaleString()}
      </Box>
    </Td>
  );
};
